export interface WizardTabInfo {
  title: string;
  description: string;
  stat: number;
}
